// extracted by mini-css-extract-plugin
export default {"broadcast-messages":"BroadcastMessages_broadcast-messages__KctT7","brodcast-message-btn":"BroadcastMessages_brodcast-message-btn__1exJw"};